import PlayerGeneralStatus from '@/components/shared/player-general-status';
import PlayersLineup from '@/components/shared/players-lineup';
import LazyLoadWrapper from '@/components/shared/wrappers/lazy-load-wrapper';
import { LEAGUES } from '@/constants/leagues';
import { PLAYER_STATUS, PLAYER_STATUS_LEVEL } from '@/constants/player-constants';

const AdminTeamAlternatives = ({
    players,
    teamId,
    ocultarPorcentajes,
    mode,
    subMode,
    league = LEAGUES.LA_LIGA,
}) => {
    if (!players || players.length === 0) return null;
    const getPlayerTeamValue = (team) => {
        return team?.id ?? team ?? teamId;
    };

    const getSquadAlternatives = () => {
        const playersNotInDataPlayers = players
            ?.filter((player) => {
                // Verifica la condición básica
                const isNotInGrid = !player?.information?.grid;

                // Evalúa la segunda condición solo si no está lesionado
                const isValidStatus =
                    player?.generalStatus?.status !== PLAYER_STATUS.INJURED ||
                    player?.generalStatus?.statusLevel !== PLAYER_STATUS_LEVEL.LARGA_DURACION;

                return isNotInGrid && isValidStatus;
            })
            ?.sort((a, b) => (b?.chance ?? 0) - (a?.chance ?? 0));

        return playersNotInDataPlayers;
    };

    const obtenerJugadoresConvocadosPorSusSelecciones = () => {
        const convocados = players?.filter(
            (x) => x?.convocatoriaSeleccion?.isConvocado && teamId === getPlayerTeamValue(x.team)
        );

        if (convocados?.length > 0) {
            return (
                <PlayerGeneralStatus
                    title={'Convocados con su selección'}
                    status={PLAYER_STATUS.CONVOCADO}
                    players={convocados}
                    displayConvocatoria={true}
                />
            );
        }
    };

    return (
        <>
            <LazyLoadWrapper>
                <PlayersLineup
                    players={getSquadAlternatives()}
                    title="Posibles recambios"
                    teamId={teamId}
                    ocultarPorcentajes={ocultarPorcentajes}
                    league={league}
                    mode={mode}
                    subMode={subMode}
                />
            </LazyLoadWrapper>

            <LazyLoadWrapper sx={{ mt: 2 }}>
                <PlayerGeneralStatus
                    title={'Dudas'}
                    status={PLAYER_STATUS.DOUBTFUL}
                    players={players?.filter(
                        (x) =>
                            x?.generalStatus?.status === PLAYER_STATUS.DOUBTFUL &&
                            teamId === getPlayerTeamValue(x.team)
                    )}
                />
            </LazyLoadWrapper>

            <LazyLoadWrapper sx={{ mt: 2 }}>
                <PlayerGeneralStatus
                    title={'Lesionados'}
                    status={PLAYER_STATUS.INJURED}
                    players={players?.filter(
                        (x) =>
                            x?.generalStatus?.status === PLAYER_STATUS.INJURED &&
                            teamId === getPlayerTeamValue(x.team)
                    )}
                />
            </LazyLoadWrapper>

            <LazyLoadWrapper sx={{ mt: 2 }}>
                <PlayerGeneralStatus
                    title={'Sancionados'}
                    status={PLAYER_STATUS.SANCTIONED}
                    players={players?.filter(
                        (x) =>
                            x?.generalStatus?.status === PLAYER_STATUS.SANCTIONED &&
                            teamId === getPlayerTeamValue(x.team)
                    )}
                />
            </LazyLoadWrapper>

            {obtenerJugadoresConvocadosPorSusSelecciones()}
        </>
    );
};

export default AdminTeamAlternatives;
